/**
 *
 * Classe responsável pela funcionalidade de exportar para csv.
 * @author adalto.junior
 *
 */

import { DefaultRequest } from 'scripts/api';

Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.ExportFormats = function () {

    this.layoutNameSpace = null;
    this.entity = null;
    this.selector = null;
    this.element = null;
    this.screenName = null;
    this.inProgress = false;
    this.action = "index";
    this.maxResult = 50000;

    this.entityToRequest = null;
    this.dataToRequest = null;

    this.setDataToRequest = function(data) {
        this.dataToRequest = data;
    };

    this.setEntityToRequest = function(entity) {
        this.entityToRequest = entity;
    };

    this.setEntity = function (entity) {
        this.entity = entity;
    };

    this.setActionToGridLayout = function (action) {
        this.action = action;
    };

    this.setSelector = function (selector) {
        this.selector = selector;
    };

    this.setElement = function (element) {
        this.element = element;
    };

    this.setLayoutNameSpace = function (layout) {
        this.layoutNameSpace = layout;
    };

    this.setCallBacks = function (callbacks) {
        this.callbacks = callbacks;
    };

    this.setScreenName = function (screenName) {
        this.screenName = screenName;
    };

    var fieldIsEnableExport = function (field) {
        var enable = true;

        switch (field) {
            case "id":
            case "principalEquipment":
            case "driversName":
            case "actualServiceTime":
            case "plannedServiceTime":
            case "baselineServiceTime":
            case "dateAutoArriveLog":
            case "tags":
            case 'route.stops.orders.salesMan':
            case 'stop.orders.salesMan':
            case 'stop.orders.lineItems.sku':
            case 'secondaryAssignments.driver':
            case 'secondaryAssignments.driver.key':
            case 'primaryAssignments.driver':
            case 'route.driverAssignments.driver.key':
                enable = false;
                break;

            default:
                break;
        }

        return enable;

    };

    /*
     * Adiciona os listeners aos elementos da interface
     */

    this.addEventListeners = function () {
        const selectorFilterExport = this.selector + ' #popupExportFormatsGridBtn';
        const selectorBtnCncel = this.selector + ' input[name=popupExportFormatsCancel_exit]';
        const selectorBtnDownload = this.selector + ' input[name=popupExportFormatsDownload]';
        const selectorCheckAll = this.selector + ' #' + this.screenName + '_exportSelectAll';

        const btnFilterExport = document.querySelector(selectorFilterExport);
        const btnCancel = document.querySelector(selectorBtnCncel);
        const btnDownload = document.querySelector(selectorBtnDownload);
        const checkSelectAll = document.querySelector(selectorCheckAll);

        const checkIfTabIsNullOrRouteMonitorAndDefineHer = () => {
            if (typeof(this.screenName) === "undefined" || this.screenName === null || this.screenName === "RouteMonitor") {
                this.setScreenName(Monet.Utils.GetTabName());
            };
        };

        if (btnFilterExport !== null) {

            btnFilterExport.onclick = () => {
                checkIfTabIsNullOrRouteMonitorAndDefineHer();

                this.togglePopUp();
                this.retrieveAllColumnsFromEntity(this.renderAllFieldsList);
                this.selectAllFieldsByDefault(checkSelectAll);
            };

        }

        if (btnCancel !== null) {

            btnCancel.onclick = () => {

                this.togglePopUp();

            };

        }

        if (btnDownload !== null) {

            btnDownload.onclick = () => {

                if (!this.inProgress) {
                    this.inProgress = true;
                    this.saveFieldList(this.entityToRequest || this.entity);
                }

            };

        }

        if (checkSelectAll !== null) {
            checkSelectAll.onclick = () => {
                if (checkSelectAll.checked) {
                    this.selectAllFields();
                } else {
                    this.unSelectAllFields();
                }

            };
        }

    };

    this.selectAllFieldsByDefault = function (selectAllButton) {
        if (selectAllButton?.checked) {
            this.selectAllFields();
        }
    };

    this.getCheckBoxElements = function () {
        const selectorAllFieldsButton =
            `${this.selector} .popupExportFormatsItems input[type='checkbox']`;
        const checkBoxElements = document.querySelectorAll(selectorAllFieldsButton);
        const totalCheckBoxElements = checkBoxElements.length;

        return {
            checkBoxElements,
            totalCheckBoxElements
        };
    };

    this.unSelectAllFields = function () {
        const {
            checkBoxElements,
            totalCheckBoxElements
        } = this.getCheckBoxElements();

        for (let i = 0; i < totalCheckBoxElements; i++) {
            const checkBoxItem = checkBoxElements[i];

            if (checkBoxItem.checked) {
                checkBoxItem.checked = false;
            }
        }
    };

    this.selectAllFields = function () {
        const {
            checkBoxElements,
            totalCheckBoxElements
        } = this.getCheckBoxElements();

        for (let i = 0; i < totalCheckBoxElements; i++) {
            const checkBoxItem = checkBoxElements[i];

            if (!checkBoxItem.checked) {
                checkBoxItem.checked = true;
            }
        }
    };

    this.retrieveAllColumnsFromEntity = function (callback) {

        var entity = this.entity;
        var that = this;

        var fields = App.Forms[this.entity].fields;
        if (!fields) {
            const request = new DefaultRequest({
                url: "form/" + entity + "/Fields",
                success: function (data) {
                    callback(data, entity, that.selector, that.screenName);
                }
            });
            request.send();
        } else {
            var fieldsArray = [];
            for(var key in fields) {
                fieldsArray.push(fields[key]);
            }
            callback(fieldsArray, entity, that.selector, that.screenName);
        }

    };

    this.renderAllFieldsList = (fieldList, entity, selector, screenName) => {
        if (typeof (this.beforeRenderAllFieldsList) !== "undefined") {
            this.beforeRenderAllFieldsList(fieldList);
        }

        var listHTML = "";
        var select = document.querySelector(selector + " .popupExportFormatsItems");

        if (typeof(fieldList) !== "undefined") {

            const visibleColumns = App.Forms[screenName].table.getColumns();

            for (var i = 0, j = fieldList.length; i < j; i++) {

                var field = fieldList[i];
                var type = field.type;

                if (type !== "PASSWORD" && type !== "LINK" && type !== "HIDDEN") {

                    var name = field.formattedName || field.name;
                    var formattedName = "";

                    if (fieldIsEnableExport(name)) {

                        var translatedField = Monet.I18n.getResourcesByKey (field.label);

                        if (field.lookupEntityColumn) {

                            if (field.meta) {

                                var metaInfo = (typeof field.meta === 'object')? field.meta : JSON.parse(field.meta);

                                if (metaInfo.hasMany) {
                                    const { entityName, collectionName } = metaInfo.hasMany;
                                    const entityNameSuffixed = entityName ? `${entityName}.` : '';

                                    formattedName = `${collectionName}.${entityNameSuffixed}${field.lookupEntityColumn}`;
                                }

                            } else {
                                if(name ) {
                                    formattedName = name + "." + field.lookupEntityColumn;
                                } else {
                                    //case of order.number on LineItem, just need lookupEntityColoumn.
                                    formattedName = field.lookupEntityColumn;
                                }
                            }

                        } else {

                            formattedName = field.formattedName || field.name;

                        }

                        const fieldToCheck = visibleColumns.find(item => item.fieldId === field.id);

                        const checkedString = fieldToCheck ? 'checked' : '';

                        listHTML += `<li class="popupExportFormatsItems" fieldId=${field.id}>`;
                        listHTML += `<input id=${screenName}_${field.id} type="checkbox" name=${formattedName} ${checkedString}>`;
                        listHTML += `<label class="columnItem" for=${screenName}_${fieldList[i].id}>${translatedField}</label>`;
                        listHTML += '</li>';

                    }
                }
            }
        }

        select.innerHTML = listHTML;
    };

    this.saveFieldList = function (entity) {
        try {
            const beforeSaveFieldList = this.callbacks?.beforeSaveFieldList;

            if (beforeSaveFieldList) {
                const beforeSaveFieldListStatus = beforeSaveFieldList();

                if (!beforeSaveFieldListStatus) {
                    new Greenmile.Components
                        .AlertModal("Monet.ExportFormats.error.noDataAvailable")
                        .show();

                    return;
                }
            }

            const fieldsSelecteds = this.getFieldsSelecteds();

            if (fieldsSelecteds.length > 0) {
              this.handlerToggleLoadingInBtn();

              const fieldsSelectedsString = fieldsSelecteds.join(",");

              var filterSort = {}, filterCriteriaChain = {}, entityToRequest = entity;
              if (this.getDataBeforeExportFormats) {
                const data = this.getDataBeforeExportFormats();
                if (data) {
                  entityToRequest = data.entityToRequest;
                  filterSort = data.filterSort;
                  filterCriteriaChain = data.filterCriteriaChain;
                }
              } else if(App?.Forms[entity]?.filterBuilder) {
                filterSort = App.Forms[entity].filterBuilder.getSort();
                filterCriteriaChain = App.Forms[entity].filterBuilder.getCriteriaChain();
              } else {
                filterCriteriaChain = {
                  criteriaChain: [{
                    'and': []
                  }]
                };
              }

              if (entity === 'NonSignatureReasonCode') {
                entityToRequest = 'ReasonCode';
              }

              if (entity === 'KronosLog') {
                entityToRequest = `ukg/${entityToRequest}`;
            }

              var columnsToSort = {
                sort: filterSort
              };

              var data = {};

              if (filterCriteriaChain?.criteriaChain?.length) {
                data.criteriaChain = filterCriteriaChain.criteriaChain;
              }

              if (columnsToSort.sort?.length) {
                data.sort = columnsToSort.sort;
              }

              if( this.dataToRequest ) {
                data.criteriaChain = [ this.dataToRequest ];
              }
              if (Object.keys(data).length) {
                const fileName = `${entity} - ${new Date().getTime()}.csv`;
                const url = `${entityToRequest}/Export/CSV?criteria={"filters":[${fieldsSelectedsString}], "firstResult": 0, "maxResults": ${this.maxResult}}`;
                Monet.Ajax.downloadCSV(fileName, url, 'post', data)
                  .then(() => {
                    this.inProgress = false;
                    this.handlerToggleLoadingInBtn();
                    this.togglePopUp();
                  })
                  .catch((e) => {
                    this.inProgress = false;
                    this.handlerToggleLoadingInBtn();
                  });
              }
            } else {
              new Greenmile.Components
                .AlertModal("Monet.ExportFormats.error.noElementSelected")
                .show();
            }

        } catch (e) {
            this.handlerToggleLoadingInBtn();
            new Monet.Exception
                .ReturnError(this, "No export format csv.", e)
                .console();
        }
    };

    this.getFieldsSelecteds = function () {

        var error = null,
            selector = this.selector + " .popupExportFormatsItems input[type='checkbox']",
            checks = null,
            totalChecks = 0,
            fields = [];

        try {

            checks = document.querySelectorAll(selector);
            totalChecks = checks.length;

            for (var i = 0; i < totalChecks; i++) {
                var check = checks[i];
                if (check.checked && !Monet.Grid.blackList(check.name)) {
                    fields.push('"' + check.name + '"');
                }
            }

            return fields;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No get selected fields.");
            error.console();

        }

    };

    this.hideOnEsc = (e) => {
        if (e.keyCode === 27) {
            this.hidePopup();
        }
    };

    this.hideOnOutsideClick = (e) => {
        if (!this.popup.contains(e.target) && !e.target.classList.contains('gridExportFormatsBtn')) {
            this.hidePopup();
        }
    };

    this.hideRemainingPopups = function() {
        const elements = document.querySelectorAll('.popupExportFormats');

        elements.forEach(element => {
            element.style.display = "none";
        })
    }

    this.hidePopup = function() {
        this.popup.style.display = "none";
        document.removeEventListener('keyup', this.hideOnEsc);
        document.removeEventListener('click', this.hideOnOutsideClick);
    }

    this.showPopup = function() {
        this.hideRemainingPopups();
        this.popup.style.display = "flex";
        document.addEventListener('keyup', this.hideOnEsc);
        document.addEventListener('click', this.hideOnOutsideClick);

        Greenmile.Utils.fixGridActionsPopupsPosition({
            buttonSelector: `.gridExportFormatsBtn.${this.entity}`,
            popupElementInstance: this.popup
        });
    }

    this.togglePopUp = function() {
        if (this.popup.style.display === "flex") {
            this.hidePopup();
        } else {
            this.showPopup();
        }
    };

    this.checkElementAndAppendChild = function (element, child) {
        if (element !== null) {
            element.appendChild(child);
        }
    };

    this.createBtn = function () {
        const translatedTitle = Monet.I18n.getResourcesByKey('exportFormats.title');

        const container = document.createElement('div');
        container.className = 'gridActionDiv';

        const btn = document.createElement('div');
        btn.id = 'popupExportFormatsGridBtn';
        btn.className = `gridExportFormatsBtn ${this.entity}`;
        btn.title = translatedTitle;

        container.appendChild(btn);

        this.checkElementAndAppendChild(this.element, container);
    };

    this.createPopUp = function () {
        let content = '<div class="popupHeader">';
            content += `<h3>${Monet.I18n.getResourcesByKey("exportFormats.title")}</h3>`;
            content += `<p>${Monet.I18n.getResourcesByKey("Monet.ExportFormats.label.description")}</p>`;
            content += '</div>';
            content += '<div class="selectAll">';
            content += `<input type="checkbox" name="exportSelectAll" id="${this.screenName}_exportSelectAll">`;
            content += `<label for="${this.screenName}_exportSelectAll" class="columnItem">${Monet.I18n.getResourcesByKey("Monet.ExportFormats.label.selectAll")}</label>`;
            content += '</div>';
            content += '<div class="popupExportFormatsList"><ul class="popupExportFormatsItems">- - -</ul></div>';
            content += '<div class="popupExportFormatsBtnGroup standard-form-buttons"></div>';
            content += '</div>';

        this.popup = document.createElement('div');
        this.popup.className = 'popupExportFormats';
        this.popup.innerHTML = content;

        this.checkElementAndAppendChild(this.element, this.popup);
        this.renderButtons();
    };

    this.renderButtons = () => {
        const selector = this.selector || `.${this.screenName}`;
        const element = document.querySelector(`${selector} .popupExportFormatsBtnGroup`);

        this.downloadBtn = new Monet.UI.Fields.Button();
        this.downloadBtn.setInputName("popupExportFormatsDownload");
        this.downloadBtn.setValue(Monet.I18n.getResourcesByKey("Monet.ExportFormats.button.download"));
        this.downloadBtn.setClassName("btn");

        this.cancelBtn = new Monet.UI.Fields.Button();
        this.cancelBtn.setInputName("popupExportFormatsCancel_exit");
        this.cancelBtn.setValue(Monet.I18n.getResourcesByKey("Monet.ExportFormats.button.cancel"));
        this.cancelBtn.setClassName("btn");

        this.checkElementAndAppendChild(element, this.downloadBtn.render());
        this.checkElementAndAppendChild(element, this.cancelBtn.render());
    };

    this.handlerToggleLoadingInBtn = function() {

        [this.downloadBtn, this.cancelBtn].map(button => {
            if(!button.rootEl.name.includes('exit')) {
                button.toggleLoadingInBtn();
            } else {
                button.toggleDisabled();
            }
        })
    };

    this.init = function () {

        //Usa a aba atual como base pra saber qual a tela atual, caso não tenha sido passada
        if (typeof(this.screenName) === "undefined" || this.screenName === null) {
            this.screenName = Monet.Utils.GetTabName();
        }

        this.createBtn();
        this.createPopUp();
        this.addEventListeners();

    };

};
